// client/src/components/marketer/project/modals/SelectContractModal.js
import React, { useState } from 'react';
import '../../../../styles/marketer/modals/ContractModals.css';

export default function SelectContractModal({ 
  open, 
  onClose, 
  influencerName,
  needsTrackingUrl,
  onConfirm 
}) {
  const [trackingUrl, setTrackingUrl] = useState('');
  const [marketerRequest, setMarketerRequest] = useState('');
  const [urlConfirmed, setUrlConfirmed] = useState(false); // ✅ 확인 여부 추적

  // ✅ 확인 버튼 핸들러 (검증 제거, 단순 확인 처리)
  const handleUrlConfirm = () => {
    if (trackingUrl.trim()) {
      setUrlConfirmed(true);
    }
  };

  // ✅ 계약 요청 버튼 활성화 조건
  const isConfirmDisabled = needsTrackingUrl && (!trackingUrl.trim() || !urlConfirmed);

  const handleConfirm = () => {
    onConfirm({
      trackingUrl: needsTrackingUrl ? trackingUrl : undefined,
      marketerRequest: marketerRequest.trim()
    });
    
    // 초기화
    setTrackingUrl('');
    setMarketerRequest('');
    setUrlConfirmed(false);
  };

  const handleClose = () => {
    setTrackingUrl('');
    setMarketerRequest('');
    setUrlConfirmed(false);
    onClose();
  };

  if (!open) return null;

  return (
    <div className="select-contract-modal mbm-overlay">
      <div className="select-contract-modal__content mbm" style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
        {/* X 버튼 */}
        <button
          className="select-contract-modal__close mbm-close"
          onClick={handleClose}
          aria-label="close"
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px'
          }}
        >
          ×
        </button>

        {/* 제목 */}
        <h2 className="select-contract-modal__title mbm-title">
          계약 요청 전, 최종 요청사항을 입력해주세요.
        </h2>
        <p className="select-contract-modal__subtitle">
          (크리에이터의 확인 및 수락 후, 프로젝트를 진행하고 결과물을 제출하게됩니다.)
        </p>

        {/* 구매당 리워드 URL (조건부) */}
        {needsTrackingUrl && (
          <div className="select-contract-modal__field">
            <label className="select-contract-modal__label">구매당 리워드 URL link</label>
            <div className="select-contract-modal__url-group">
              <input
                type="text"
                placeholder="URL link"
                value={trackingUrl}
                onChange={(e) => {
                  setTrackingUrl(e.target.value);
                  setUrlConfirmed(false); // ✅ 수정 시 확인 상태 리셋
                }}
                disabled={urlConfirmed} // ✅ 확인 후 수정 불가
                className={`select-contract-modal__input ${urlConfirmed ? 'select-contract-modal__input--confirmed' : ''}`}
              />
              <button 
                className={`select-contract-modal__validate-btn ${urlConfirmed ? 'select-contract-modal__validate-btn--confirmed' : ''}`}
                onClick={handleUrlConfirm}
                disabled={!trackingUrl.trim() || urlConfirmed}
              >
                {urlConfirmed ? '✓ 확인됨' : '확인'}
              </button>
            </div>
            {urlConfirmed && (
              <p className="select-contract-modal__confirm-msg">
                ✓ URL이 확인되었습니다.
              </p>
            )}
          </div>
        )}

        {/* 요청사항 */}
        <div className="select-contract-modal__field">
          <label className="select-contract-modal__label">
            선정하는 크리에이터에게의 요청사항
          </label>
          <textarea
            placeholder="요청사항"
            value={marketerRequest}
            onChange={(e) => setMarketerRequest(e.target.value)}
            className="select-contract-modal__textarea"
            rows={8}
          />
        </div>

        {/* 완료 버튼 */}
        <div className="mbm-foot">
          <button
            className="mb-btn mb-btn-primary"
            onClick={handleConfirm}
            disabled={isConfirmDisabled}
          >
            계약 요청(완료)
          </button>
        </div>
      </div>
    </div>
  );
}
